import ProOnboardingCTA from './ProOnboardingCTA';
import ProOnboardingCTAModal from './modal';

export { ProOnboardingCTAModal };
export default ProOnboardingCTA;
